import { GetLoginUserResult } from './get-login-user-result';

export class GetLoginUserResponse {
    status: string;
    message: string;
    result: GetLoginUserResult;
}
